import React from 'react';
import Search from "../Search/Search";
import Layer from "../QuyHoach/Layer";
import MapMode from "../Menu/MapMode";
import Server from "../Menu/Server";
import Location from "../Menu/Location";
import ZonePanel from "../QuyHoach/ZonePanel";
import Login from "../Profile/Login";
import Result from "../Search/Result";
import Info from "../HienTrang/Info";
import Account from "../Profile/Account";
import DrawingManager from '../Drawing/Advance/DrawingAdvance';

const ContentRightPanel = ({ route }) => {
    // console.log(route)
    switch (route) {
        // case "search":
        //     return (
        //         <Search />
        //     );
        case "layer":
            return (
                <Layer />
            );
        case "satellite":
            return (
                <MapMode />
            );
        case "server":
            return (
                <Server />
            );
        case "location":
            return (
                <Location />
            );
        case "zone":
            return (
                <ZonePanel />
            );
        case "login":
            return (
                <Login route='login' />
            );
        case "result":
            return (
                <Result />
            );
        case "info":
            return (
                <Info />
            );
        case "account":
            return (
                <Account />
            );
        case "changePassword":
            return (
                <Login route='changePassword' />
            );
        case "drawingManager":
            return (
                <DrawingManager />
            );
        // case "panelQuyHoachInfo":
        //     return (
        //        <PanelQuyHoachInfo />
        //     );
        default:
            return null
    }
}

export default ContentRightPanel
